import { ResolveAiFieldProposalInput } from "src/generated/graphqlTypes";
import { ObjectConfig } from "src/utils/formState";
import { type AiFormAfpFragment } from "./aiProposalForm.generated";

export type AiFieldProposalFormValue = ResolveAiFieldProposalInput &
  Pick<AiFormAfpFragment, "fieldName" | "fieldValue" | "parentType" | "pageNumbers">;

/** Nest as `fieldProposals: { type: "list", update: "incremental", config: aiFieldProposalConfig }` on a form that reviews AI field proposals. `fieldName`/`fieldValue` are server-owned; `status` is what Accept/Reject writes. */
export const aiFieldProposalConfig: ObjectConfig<AiFieldProposalFormValue> = {
  id: { type: "value" },
  fieldName: { type: "value", readOnly: true },
  fieldValue: { type: "value", readOnly: true },
  // parentType is readOnly server metadata that identifies CREATE/DELETE proposals.
  parentType: { type: "value", readOnly: true },
  // readOnly, and backs the field's `Sources:` links.
  pageNumbers: { type: "value", readOnly: true },
  status: { type: "value" },
};
